import { render, staticRenderFns } from "./ItemListSideMenu.vue?vue&type=template&id=1dc4f798&scoped=true"
import script from "./ItemListSideMenu.vue?vue&type=script&lang=js"
export * from "./ItemListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./ItemListSideMenu.vue?vue&type=style&index=0&id=1dc4f798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc4f798",
  null
  
)

export default component.exports